export const TRANSFORM_TEMPLATE = `# Uncomment and customize the function below to enable importing sessions
# into test sets. Until this function is defined, "Import from Sessions"
# will not be available.
#
# def transform_session(session) -> dict:
#     """Convert a session into workflow input/output for test set creation.
#
#     Args:
#         session: Session object with:
#             session.session_id: str
#             session.company_id: int
#             session.timeline: list of turns, each with:
#                 turn.request.params.messages: list of {role, content}
#                 turn.response.choices[0].message.content: str
#
#     Returns:
#         {"input": <workflow_input>, "output": <expected_output>}
#         - input: what would be sent as ctx.input when executing the workflow
#         - output: the expected result (used for test comparison)
#     """
#     workflow_input = {}
#     workflow_output = {"content": ""}
#
#     if not session.timeline:
#         return {"input": workflow_input, "output": workflow_output}
#
#     first_turn = session.timeline[0]
#     if first_turn.request and first_turn.request.params and first_turn.request.params.messages:
#         for msg in first_turn.request.params.messages:
#             if msg.role == "user" and msg.content:
#                 workflow_input["query"] = msg.content
#                 break
#
#     last_turn = session.timeline[-1]
#     if last_turn.response and last_turn.response.choices:
#         content = last_turn.response.choices[0].message.content or ""
#         workflow_output = {"content": content}
#
#     return {"input": workflow_input, "output": workflow_output}
`;

export interface S3Version {
  version_id: string;
  last_modified: string;
  size: number;
  is_latest: boolean;
  is_deployed: boolean;
}

export const MONACO_JSON_OPTIONS = {
  minimap: { enabled: false },
  fontSize: 13,
  lineNumbers: "on" as const,
  scrollBeyondLastLine: false,
  wordWrap: "on" as const,
  tabSize: 2,
  automaticLayout: true,
  padding: { top: 16, bottom: 16 },
};

export const MONACO_PYTHON_OPTIONS = {
  ...MONACO_JSON_OPTIONS,
  tabSize: 4,
  insertSpaces: true,
};

export const DEFAULT_SCHEMA = "{\n\n}";
